// 画面で利用している主要な色
export const Colors = {
  Orange: "#FF8200",
  Navy: "0046ae",
  White: "#FFF",
  Gray: "#D6D6D6",
  DarkGray: "#666666"
}
// バリデーションエラーのメッセージ一覧
export const ErrorMessages = {
  REQUIRED: "必須項目です。ご入力ください。",
  NOT_SELECTED: "必須項目です。ご選択ください。",
  IS_NOT_EMAIL_FORMAT: "メールアドレスのフォーマットが正しくありません。再度ご入力ください。",
  NO_CAR_MODEL:
    "該当する型式は見つかりませんでした。再入力してください。また、お車の情報とあわせて、お申込みが可能か確認させていただきますので、サポートセンター（0120-253-325）へご連絡ください。",
  INELIGIBLE_CAR_TYPE: "お客様の用途車種はお見積りの対象外となります。",
  IS_WRONG_CERTIFiCATE_COLOR: "免許証の色と記名被保険者の年齢をご確認ください。( ゴールド免許：21歳以上 )",
  IS_NOT_SAME_EMAIL: "メールアドレスと確認用メールアドレスが一致しません。入力情報をご確認ください。",
  IS_NOT_CHARACTER_LIMIT: "パスワードは7文字以上～10文字以下にしてください。",
  IS_NOT_NUMBER_ALPHABET: "パスワードは半角の英字と数字の組合せで入力してください。",
  IS_SAME_EMAIL_ID: "パスワードはメールアドレスの@より前と異なる文字列にしてください。",
  MODEL_TYPE_INCOMPATIBGLE:
    "用途車種と型式がデータベースと一致しませんでした。型式と用途車種を改めてご確認ください。また、入力に誤りがない場合、お車の情報とあわせて、お申込みが可能か確認させていただきますので、サポートセンター（0120-253-325）へご連絡ください。",
  MODEL_INSPECTION_DATE_INCOMPATIBLE:
    "初度登録年月に発売年月より前の日付を指定することはできません。お申込みが可能か確認させていただきますので、サポートセンター（0120-253-325）へご連絡ください",
  VERSION_UP: "WEBサイトの情報が更新されましたので、お手数ですが再度ご試算ください。（保険商品の改定）"
}
// 免許証の色のAPI定義
export const DriversLicenseColor = {
  Blue: 0,
  Gold: 1,
  Green: 2
}
// ノンフリート等級のAPI定義
export const NonFleetGrade = {
  Grade1: "001",
  Grade2: "002",
  Grade3: "003",
  Grade4: "004",
  Grade5: "005",
  Grade6F: "06F",
  Grade6S: "06S", // ※純新規のとき
  Grade7F: "07F",
  Grade7S: "07S", // ※複数所有新規のとき
  Grade8: "008",
  Grade9: "009",
  Grade10: "010",
  Grade11: "011",
  Grade12: "012",
  Grade13: "013",
  Grade14: "014",
  Grade15: "015",
  Grade16: "016",
  Grade17: "017",
  Grade18: "018",
  Grade19: "019",
  Grade20: "020"
}

export const PLANLIST = {
  LIGHT: "light",
  NORMAL: "normal",
  PREMIUM: "premium"
}

export const WindowSize = {
  MobileMaxWidth: 639,
  TabletMaxWidth: 959
}
// 特約割引増のAPI定義
export const SpecialContractDiscount = {
  新車割引: "E7",
  おとなの早割50日: "U7",
  おとなの早割30日: "U6",
  ゴールド免許割引: "E4",
  "電気・ハイブリッド車割引": "U2",
  複数所有新規割引: "C3",
  インターネット割引: "Eﾜ",
  "自動ブレーキ（ＡＳＶ）割引": "6D",
  無事故割引: "86"
}
// 特定特約のAPI定義
export const DesignatedSpecialContract = {
  車両無過失事故に関する特約: "59",
  事故時代車費用特約: "M1",
  他車運転特約: "CQ",
  ロードアシスタンス特約: "91",
  個人賠償責任特約: "TV",
  弁護士費用特約: "CH",
  継続うっかり特約: "63",
  契約自動車の入替自動補償特約: "62",
  人身車外補償特約: "87",
  車対車事故および限定危険補償特約: "5H",
  車両新価特約: "Cｴ",
  被害者救済費用特約: "5N",
  対物全損時修理差額費用特約: "Eｾ",
  車両全損修理時特約: "53",
  自転車傷害特約: "5M",
  車両積載動産特約: "C1"
}
export const API_TIMEOUT = { timeout: 1000 * 60 }
// プランのAPI定義
export const PLANS = {
  FULLSUPPORT: "1",
  STANDARD: "2",
  LIGHT: "3"
}
// URL
export const APP_URL = {
  TOP: "/",
  USAGE: "/scan",
  UPLOAD: "/upload",
  RESULT: "/car",
  CONDITIONS: "/estimate",
  COMPLETE: "/save",
  FINISHED: "/complete",
  PLANS: "/plan",
  Estimable: "/target",
  ERROR: "/error",
  MAINTENANCE: "/maintenance"
}
// JSON値 → 画面表示変換用（用途車種）
export const CAR_TYPE_FROM_API = {
  "11": "自家用普通乗用車",
  "13": "自家用小型乗用車",
  "31": "自家用軽四輪乗用車",
  "33": "自家用軽四輪貨物車",
  "49": "自家用小型貨物車"
}
// JSON値 → 画面表示変換用（免許証の色）
export const LICENSE_COLOR_FROM_API = {
  "0": "ブルー",
  "1": "ゴールド",
  "2": "グリーン"
}
// JSON値 → 画面表示変換用（使用目的）
export const PURPOSE_FROM_API = {
  "1": "日常･レジャー",
  "2": "通勤・通学",
  "3": "業務使用"
}
// JSON値 → 画面表示変換用（運転者範囲）
export const DRIVER_SCOPE_FROM_API = {
  Eﾃ: "運転者限定特約（本人補償型）",
  Eﾔ: "運転者限定特約（本人・配偶者・別居未婚の子補償型）",
  "11": "運転者限定特約（同居の子以外補償型）",
  EB: "運転者限定なし特約（同居の子年齢条件設定型）",
  "11_BUSINESS": "運転者限定特約（同居の子・使用人以外補償型）",
  EB_BUSINESS: "運転者限定なし特約（同居の子・使用人年齢条件設定型）"
}
// 保険金を請求したお車の事故区分
export const HAD_ACCIDENT = {
  NO_ACCIDENT: "事故なし",
  PAST_2_3_YEARS: "過去２～３年以内に事故あり",
  PAST_1_YEAR: "過去１年以内に事故あり"
}
